import axios from "axios";
import { getEnvironment } from "./shared/utility";
//uses the proxy if it's in dev

let apiUrl = getEnvironment();
let instance = axios.create({ baseURL: apiUrl });
instance.defaults.timeout = 60000;
export default instance;
